import React from "react";
import { Table } from "antd";

const Rendertable = ({ data, loading, total, current, pageSize, onChange }) => {
  const columns = [
    {
        title: "Transfer Number",
        dataIndex: "transfer_number",
        key: "transfer_number",
      },
    {
      title: "Product Details",
      dataIndex: "product_details",
      key: "product_details",
    },

    {
      title: "Product Attributes",
      dataIndex: "product_attributes",
      key: "product_attributes",
      render: (attributes) => attributes.join(", "),
    },
    {
        title: "Quantity",
        dataIndex: "quantity",
        key: "quantity",
      },
    {
      title: "Product Category",
      dataIndex: "product_category",
      key: "product_category",
    },

    {
      title: "Source",
      dataIndex: "source",
      key: "source",
    },
    {
      title: "Distance",
      dataIndex: "destance",
      key: "distance",
    },
  ];

  // let page_sizes = [5, 10, 20, 50, 100, 500, 1000, 5000, 10000];
  // let page_size_opt = [];
  // for (let i = 0; i < page_sizes.length; i++) {
  //   if (page_sizes[i] < total) {
  //     page_size_opt.push(page_sizes[i]);
  //   }
  // }
  // page_size_opt.push(total);

  const paginationConfig = {
    current: current,
    pageSize: pageSize,
    total: total,
    onChange: onChange,
    showSizeChanger: true,
    // pageSizeOptions: page_size_opt.map(String),
  };

  return (
    <Table
      columns={columns}
      dataSource={data}
      loading={loading}
      rowKey={(record) => record.id}
      pagination={paginationConfig}
    />
  );
};

export default Rendertable;
